var map = {
	"./beforeLogin.json": 8829,
	"./componentWysiwig.json": 359,
	"./form_general.json": 4366,
	"./gallery.json": 1487,
	"./image.json": 4776,
	"./inputSegment.json": 3430,
	"./invoice.json": 9193,
	"./invoiceCompany.json": 7005,
	"./json_input.json": 9402,
	"./layout.json": 8669,
	"./list_general.json": 8940,
	"./location.json": 5348,
	"./restaurant.json": 6796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7258;